import ProfileIconFilled from 'icons/profile-filled.svg';

import { AvatarIcon, PersonBio, PersonImage, PersonInfoWrapper, PersonName, Wrapper } from './styles';
import { ProgramNarratorProps } from './types';

const ProgramNarrator = ({ program }: ProgramNarratorProps) => {
	const getNarratorImage = () => {
		const imageUrl = program.narrator?.headshot?.url;

		return imageUrl ? (
			<PersonImage src={imageUrl} alt="" />
		) : (
			<AvatarIcon as={ProfileIconFilled}></AvatarIcon>
		);
	};

	if (!program.narrator) {
		return null;
	}

	return (
		<Wrapper>
			{getNarratorImage()}
			<PersonInfoWrapper>
				<PersonName>{program.narrator?.name}</PersonName>
				<PersonBio>{program.narrator?.short_bio}</PersonBio>
			</PersonInfoWrapper>
		</Wrapper>
	);
};

export default ProgramNarrator;
